import { ReactLoader } from '../../loaders';

interface IOtpInputFieldDummyProps {
  otpLength: number;
}

/**
 * -----------------------------------------------------------------------------
 * This is shown as a replacement when the OTP is loading.
 */
export function OtpInputFieldDummy({ otpLength }: IOtpInputFieldDummyProps) {
  return (
    <div className="deprecated-otp-input-field-wrapper">
      {Array.from(Array(otpLength).keys()).map((digit) => (
        <span key={digit} className="otp-input otp-loading cursor-wait">
          <ReactLoader />
        </span>
      ))}
    </div>
  );
}
